import * as React from 'react';
import { FormGroup, FormControl } from 'react-bootstrap';
import * as ReactDOM from 'react-dom';

export default class ChapterTitleComponent extends React.Component<any, any> {

    // private formControlRef: React.RefObject<any>;
    private chapterTitle = this.props.currentChapterName

    constructor(props:any) {
        super(props);

        this.state = {
            chapterTitle: this.chapterTitle,
        }

        // this.formControlRef = React.createRef();

        this.onChapterNameInputChange = this.onChapterNameInputChange.bind(this);
        this.onUpdateChapterName = this.onUpdateChapterName.bind(this);
        this.focus = this.focus.bind(this);
    }

    private onUpdateChapterName(e:any) {
        e.preventDefault();
        this.props.onChapterNameUpdated(this.state.chapterTitle)
    }

    private onChapterNameInputChange(event) {
        this.setChapterName(event.target.value);
    }
    
    public setChapterName(chapterName:string) {
        this.setState({chapterTitle: chapterName});
    }

    public getChapterName():string {
        return this.state.chapterTitle;
    }

    public focus():void {
        // var authorInput = ReactDOM.findDOMNode<HTMLInputElement>(this.refs["author"]);
        let input = ReactDOM.findDOMNode(this.refs["titleInput"]) as HTMLInputElement;
        console.log(input, this.refs["titleInput"], this.refs)
        input.focus();
    }

    private handleFocus(e) {
        e.target.select();
    }

    render() {
        return (
            <form onSubmit={this.onUpdateChapterName}>
                <FormGroup
                    controlId="formBasicText"
                    >
                    <FormControl
                        ref={"titleInput"}
                        value={this.state.chapterTitle}
                        className="chapterTitleInput"
                        type="text"
                        onChange={this.onChapterNameInputChange}
                        onFocus={this.handleFocus}
                    />
                </FormGroup>
            </form>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/storyEditComponent/ChapterTitleComponent.tsx